import { BiX } from 'react-icons/bi';

function modalContentClass({ isFullScreen, size }) {
  if (size === 'viewport') {
    return 'modal-content-viewport';
  }
  if (isFullScreen) {
    return 'modal-content-fullscreen';
  }
  return 'modal-content';
}

function Modal({
  isOpen,
  onClose,
  isFullScreen,
  size,
  children,
  className = '',
  contentStyle,
}) {
  if (!isOpen) {
    return null;
  }

  const contentClassName = [
    modalContentClass({ isFullScreen, size }),
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="modal-overlay">
      <div className={contentClassName} style={contentStyle}>
        {onClose ? (
          <div className="modal-close-button" style={{ cursor: 'pointer' }}>
            <BiX size={'1.2rem'} onClick={onClose} />
          </div>
        ) : (
          <></>
        )}

        {/* <button className="modal-close-button" onClick={onClose}>
                   &times;
                </button> */}
        {children}
      </div>
    </div>
  );
}

export default Modal;
